import { Text, View } from "@react-pdf/renderer";
import LogoPortrait from "../graphics/LogoPortrait";
import LogoWireframe from "../graphics/LogoWireframe";
import { color } from "../styles";

type HeaderProps = { title: string; subtitle?: string };

const Header: React.FC<HeaderProps> = (props) => {
  const { title, subtitle } = props;

  return (
    <View style={{ paddingTop: 35, paddingHorizontal: 60 }}>
      <LogoWireframe width={240} style={{ position: "absolute", top: -40, right: -60 }} />

      <View
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 35,
          gap: 50,
        }}
      >
        <LogoPortrait width={65} />

        <View>
          {subtitle && <Text style={{ fontSize: 16 }}>{subtitle}</Text>}

          <Text style={{ fontSize: 30, maxWidth: 240 }}>{title}</Text>
        </View>
      </View>

      <View style={{ width: 340, borderBottom: `1px solid ${color.darkGrey}` }} />
    </View>
  );
};

export default Header;
